import React, { useEffect, useState, useRef } from "react";
import "./navbar.css";
import Hamburger from "../../components/hamburger/Hamburger";
import logo from "../../assets/imgs/navbar_img/RBS_Logo_V3.svg";
import lg_facebook from "../../assets/imgs/navbar_img/lg_facebook.png";
import lg_instagram from "../../assets/imgs/navbar_img/lg_instagram.png";
import lg_search from "../../assets/imgs/navbar_img/lg_search.png";
import lg_twitter from "../../assets/imgs/navbar_img/X_Twitter_Logo.svg";
import lg_youtube from "../../assets/imgs/navbar_img/lg_youtube.png";
import navbar_line from "../../assets/imgs/navbar_img/navbar_line.png";
import menu_movil from "../../assets/imgs/navbar_img/Menu_movil.png";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
// import Suscribir from '../../pages/Suscrib';
import Modal2 from "../../components/modalSus/ModalSus";
// import Contenido from '../Detalle_blog/contenido/Contenido';

const Navbar = (props) => {
  const [lang, setLang] = useState(localStorage.getItem("language") || "es");
  // const [langText, setLangText] = useState(lang === 'es' ? 'English' : 'Español');
  const [langText, setLangText] = useState(
    lang === "es" ? "English" : "Spanish"
  );
  const [t, i18n] = useTranslation("global");
  const isFirstRender = useRef(true);
  const location = useLocation();
  const navigate = useNavigate();
  const queryParms = new URLSearchParams(location.search);
  console.log(queryParms.get("lang"));
  const inputRef = useRef(null);
  const inputRef2 = useRef(null);
  const inputRef3 = useRef(null);
  const [inputVal, setInputVal] = useState('');

  const langQueryParams = queryParms.get("lang");
  const [popup, setPopup] = useState(false); // Initialize the state in the parent component

  useEffect(() => {
    const urlLang = location.pathname.split("/")[1];
    if (["es", "en"].includes(urlLang)) {
      setLang(urlLang);
      localStorage.setItem("language", urlLang);
      i18n.changeLanguage(urlLang);
      setLangText(urlLang === "es" ? "English" : "Spanish");
    } else if (["es", "en"].includes(langQueryParams)) {
      setLang(langQueryParams);
      localStorage.setItem("language", langQueryParams);
      i18n.changeLanguage(langQueryParams);
      setLangText(langQueryParams === "es" ? "English" : "Spanish");
    } else {
      i18n.changeLanguage(lang);
      localStorage.setItem("language", lang);
    }
  }, [lang]);


  const changeLanguage = () => {
    console.log(lang);
    const newLang = lang === "es" ? "en" : "es";
    setLang(newLang);
    setLangText(newLang === "es" ? "English" : "Spanish");

    const urlLang = location.pathname.split("/")[1];
    if (["es", "en"].includes(urlLang)) {
      const newRoute = `/${newLang}${location.pathname.replace(
        `/${lang}`,
        ""
      )}`;
      navigate(newRoute);
    } else if (["es", "en"].includes(langQueryParams)) {
      const newSearchParams = new URLSearchParams(location.search);
      newSearchParams.set("lang", newLang);
      const newRoute = `${location.pathname}?${newSearchParams.toString()}`;
      navigate(newRoute);
    }
  };

  // useEffect(() => {
  //     // Si popup es true, resetéalo a false después de 3 segundos (3000 milisegundos)
  //     if (popup) {
  //     //   const timer = setTimeout(() => {
  //         setPopup(false);
  //     //   }, 3000); // 3000 milisegundos = 3 segundos
  //       // Limpia el temporizador cuando el componente se desmonta o cuando popup cambia
  //       return (setPopup);
  //     }
  //   }, [popup]);

  const [isModalOpen2, setIsModalOpen2] = useState(false);

  const [mostrarInput, setMostrarInput] = useState(false);

  const handleButtonClick = () => {
    // Cambiar el estado para mostrar el input
    setMostrarInput(true);
  };

  const openModal2 = () => {


    setIsModalOpen2(true);
  };

  const closeModal2 = () => {
    setIsModalOpen2(false);
  };

  const handleInputChange = (event) => {
    setInputVal(event.target.value);
  };

  const handleClick = () => {
    if (inputVal != null && inputVal != '') {
      window.location.href = "/es/busqueda/" + inputVal;
    }
  };

  const handleKeyDown = (e) => {
    // Verificar si la tecla presionada es "Enter" (código 13)
    if (e.key === 'Enter') {
      handleClick();
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      // Verificar si el clic ocurrió fuera del input
      if (inputRef.current && !inputRef.current.contains(event.target) && !inputRef2.current.contains(event.target) && (!inputRef3.current || !inputRef3.current.contains(event.target))) {
        // Ocultar el input si está visible
        if (mostrarInput) {
          setMostrarInput(false);
        }
      }
    };

    // Agregar el manejador de eventos cuando el componente se monta
    document.addEventListener('mousedown', handleClickOutside);

    // Limpiar el manejador de eventos cuando el componente se desmonta
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [mostrarInput]); // Este efecto se ejecuta cada vez que mostrarInput cambia


  // Función para hacer focus en el input
  const hacerFocus = () => {
    // Verificar que la referencia no sea null antes de llamar al método focus
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  useEffect(() => {
    if (mostrarInput) {
      hacerFocus();
    }
  }, [mostrarInput]);

  const clearSearch = () => {
    setInputVal('');
  };

  return (
    // setIsModalOpen2(true);
    <div className={`navbar_rbs ${props.link ? 'navbar_rbs_libros' : ''}`}>
      <div className="navbar_Logo">
        <a href={"/" + lang + "/"}>
          <img className="navbar_logorbs" alt="RBS Logo" src={logo} />
        </a>
      </div>
      <div className={`navbar_redessociales ${props.link ? 'navbar_redeslibros' : ''}`}>
        <a
          href="https://www.youtube.com/channel/UCovDaTdisIRpyFqQsNGMNsQ"
          target="_blank"
          className="navbar_bt"
        >
          <svg viewBox="-143 145 512 512">
            <path d="m78.9 450.3 83.8-49.2-83.8-49.2z" />
            <path d="M113 145c-141.4 0-256 114.6-256 256s114.6 256 256 256 256-114.6 256-256-114.6-256-256-256zm128 301.8c0 44.1-44.1 44.1-44.1 44.1H29.1c-44.1 0-44.1-44.1-44.1-44.1v-91.5c0-44.1 44.1-44.1 44.1-44.1h167.8c44.1 0 44.1 44.1 44.1 44.1v91.5z" />
          </svg>
        </a>
        <a
          href="https://twitter.com/ricardobsalinas"
          target="_blank"
          className="navbar_bt"
        >
          <svg viewBox="0 0 256 256" className="especial">
            <defs></defs>
            <g transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)">
              <polygon
                points="24.89,23.01 57.79,66.99 65.24,66.99 32.34,23.01 "
                transform="  matrix(1 0 0 1 0 0) "
              />
              <path
                d="M 45 0 L 45 0 C 20.147 0 0 20.147 0 45 v 0 c 0 24.853 20.147 45 45 45 h 0 c 24.853 0 45 -20.147 45 -45 v 0 C 90 20.147 69.853 0 45 0 z M 56.032 70.504 L 41.054 50.477 L 22.516 70.504 h -4.765 L 38.925 47.63 L 17.884 19.496 h 16.217 L 47.895 37.94 l 17.072 -18.444 h 4.765 L 50.024 40.788 l 22.225 29.716 H 56.032 z"
                transform=" matrix(1 0 0 1 0 0) "
                strokeLinecap="round"
              />
            </g>
          </svg>
        </a>
        <a
          href="https://www.facebook.com/RicardoSalinasPliego"
          target="_blank"
          className="navbar_bt"
        >
          <svg viewBox="0 0 256 256">
            <defs></defs>
            <g transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)">
              <path
                d="M 45 -0.228 c -24.853 0 -45 20.25 -45 45.229 c 0 22.806 16.797 41.66 38.633 44.77 V 58.779 h -10.64 V 46.328 h 10.64 v -9.182 c 0 -10.656 6.441 -16.458 15.849 -16.458 c 4.506 0 8.38 0.339 9.508 0.491 v 11.136 l -6.525 0.003 c -5.116 0 -6.107 2.457 -6.107 6.061 v 7.949 h 12.202 l -1.589 12.451 H 51.359 v 30.993 C 73.199 86.666 90 67.81 90 45.001 C 90 20.022 69.853 -0.228 45 -0.228 z"
                transform=" matrix(1 0 0 1 0 0) "
                strokeLinecap="round"
              />
            </g>
          </svg>
        </a>
        <a
          href="https://www.instagram.com/ricardosalinas/?hl=es-la"
          target="_blank"
          className="navbar_bt"
        >
          <svg
            width="19.2px"
            height="19.2px"
            viewBox="0 0 19.2 19.2"
            data-name="Instagram w/circle"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M13.498 6.651a1.656 1.656 0 0 0-.95-.949 2.766 2.766 0 0 0-.928-.172c-.527-.024-.685-.03-2.02-.03s-1.493.006-2.02.03a2.766 2.766 0 0 0-.929.172 1.656 1.656 0 0 0-.949.95 2.766 2.766 0 0 0-.172.928c-.024.527-.03.685-.03 2.02s.006 1.493.03 2.02a2.766 2.766 0 0 0 .172.929 1.656 1.656 0 0 0 .95.949 2.766 2.766 0 0 0 .928.172c.527.024.685.029 2.02.029s1.493-.005 2.02-.03a2.766 2.766 0 0 0 .929-.171 1.656 1.656 0 0 0 .949-.95 2.766 2.766 0 0 0 .172-.928c.024-.527.029-.685.029-2.02s-.005-1.493-.03-2.02a2.766 2.766 0 0 0-.171-.929zM9.6 12.168A2.568 2.568 0 1 1 12.168 9.6 2.568 2.568 0 0 1 9.6 12.168zm2.669-4.637a.6.6 0 1 1 .6-.6.6.6 0 0 1-.6.6zM11.267 9.6A1.667 1.667 0 1 1 9.6 7.933 1.667 1.667 0 0 1 11.267 9.6zM9.6 0a9.6 9.6 0 1 0 9.6 9.6A9.6 9.6 0 0 0 9.6 0zm4.97 11.661a3.67 3.67 0 0 1-.233 1.214 2.556 2.556 0 0 1-1.462 1.462 3.67 3.67 0 0 1-1.213.233c-.534.024-.704.03-2.062.03s-1.528-.006-2.062-.03a3.67 3.67 0 0 1-1.213-.233 2.556 2.556 0 0 1-1.462-1.462 3.67 3.67 0 0 1-.233-1.213c-.024-.534-.03-.704-.03-2.062s.006-1.528.03-2.062a3.67 3.67 0 0 1 .232-1.213 2.556 2.556 0 0 1 1.463-1.463 3.67 3.67 0 0 1 1.213-.232c.534-.024.704-.03 2.062-.03s1.528.006 2.062.03a3.67 3.67 0 0 1 1.213.232 2.556 2.556 0 0 1 1.462 1.463 3.67 3.67 0 0 1 .233 1.213c.024.534.03.704.03 2.062s-.006 1.528-.03 2.062z" />
          </svg>
        </a>

        <a
          href="https://www.tiktok.com/discover/ricardo-salinas-pliego?lang=es"
          target="_blank"
          className="navbar_bt"
        >
          <svg
            width="19.2px"
            height="19.2px"
            viewBox="0 0 512 512"
            data-name="Tiktok w/circle"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M256,0C114.615,0,0,114.615,0,256S114.615,512,256,512,512,397.385,512,256,397.385,0,256,0ZM385.62,232.382c-27.184,0-53.634-8.822-74-23.75l-.162,101.5a92.457,92.457,0,1,1-80.178-91.721v49.845a43.657,43.657,0,1,0,31.288,41.876V109.333h51.275a71.773,71.773,0,0,0,71.774,71.773Z" />
          </svg>
        </a>
      </div>

      <div className="navbar_line">
        <img src={navbar_line} />
      </div>

      <div className="navbar_menu">
        <a href={"/" + lang + "/Sobre-mi"} class="textstyle">
          {t("navbar.sobre-mi")}
        </a>
        <a href={"/" + lang + "/Ideas-en-Corto"} class="textstyle">
          {t("navbar.ideas-corto")}
        </a>
        <a href={"/" + lang + "/Ideas-en-libertad"} class="textstyle">
          {t("navbar.ideas-libertad")}
        </a>
        <a href={"/" + lang + "/biblioteca"} class="textstyle">
          {t("navbar.biblioteca")}
        </a>
      </div>

      <div className="navbar_line">
        <img src={navbar_line} />
      </div>

      <div className="navbar_extras">

        <button className="navbar_search" onClick={handleButtonClick}>
          <img src={lg_search} />
        </button>

        {/* Mostrar el input si mostrarInput es true */}
        {mostrarInput && (
          <div className="div_search_nav">
            <input type="text"
              ref={inputRef}
              placeholder={(t('navbar.buscador2'))}
              value={inputVal}
              onChange={handleInputChange}
              onKeyDown={handleKeyDown} />
            {inputVal && (
              <button
                onClick={clearSearch}
                ref={inputRef3}
                style={{
                  position: 'absolute',
                  right: '43px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  background: 'transparent',
                  border: 'none',
                  cursor: 'pointer',
                  fontSize: '22px',
                  color: '#888',
                }}
              >
                &#x2715; {/* Esto es el símbolo de "X" */}
              </button>
            )}
            <img src={lg_search} ref={inputRef2} onClick={handleClick} />
          </div>
        )}

        <button className="navbar_suscribirse" onClick={() => openModal2()}>
          {t("general.suscribirse")}
        </button>

        {props.link ? (
          <button
            className="navbar_suscribirse"
            onClick={() => window.open(props.link)}
            style={{ margin: "0 10px" }}
          >
            {t("general.buy")}
          </button>
        ) : null}

        {props.link2 ? (
          <a className="navbar_suscribirse navbar_suscribirse_buy_b" href={props.link2}>
            {t("general.buy")}
          </a>
        ) : null}

        <a id="btn_cm_idm" className="navbar_extraitem textstyle" onClick={changeLanguage}>
          {langText}
        </a>
      </div>
      <div className="navbar_movil">
        <Hamburger />
      </div>

      <Modal2 isOpen={isModalOpen2} closeModal={closeModal2} />
    </div>
  );
};

export default Navbar;
